import React, { useEffect, useState } from 'react'
import { Tabs, Swiper } from 'antd-mobile'
import { RightOutlined } from '@ant-design/icons'
import Preview from './Preview'
import general from '../../../general'
import Dialog from '../../../lib/Dialog'
import { NavLink } from '../../../lib/Navigation'
import DisableGames from './DisableGames'

export default function ExclusivePrivilegesItem(props) {

  const [item, setItem] = useState(props.item)
  const [tagActiveIndex, setTagActiveIndex] = useState(0)
  const [visible, setVisible] = useState(false)
  const [gamesVisible, setGamesVisible] = useState(false)
  const [isClose, setIsClose] = useState(true)
  const [voucher, setVoucher] = useState({})

  useEffect(() => {
    if (item?.levelNav?.length > 0) {
      setTagActiveIndex(0)
      let amount = 0
      let meet_amount = 0
      let time = ''
      item.levelNav[0].vouchers?.map((vch) => {
        amount += parseInt(vch.amount) * parseInt(vch.num)
        meet_amount += parseInt(vch.num)
        time = vch.time
      })
      setVoucher({
        amount: amount,
        meet_amount: '总价值',
        name: `共${meet_amount}张代金券`,
        time: time
      })
    }

    item.levelNav.map((obj, index) => {
      if (obj.level == props.level) {
        setTagActiveIndex(index)
        let amount = 0
        let meet_amount = 0
        let time
        obj.vouchers?.map((vch) => {
          amount += parseInt(vch.amount) * parseInt(vch.num)
          meet_amount += parseInt(vch.num)
          time = vch.time
        })
        setVoucher({
          amount: amount,
          meet_amount: '总价值',
          name: `共${meet_amount}张代金券`,
          time: time
        })
      }
    })
  }, [props.level])

  const handleReceive = (item) => {
    if (item.levelNav[tagActiveIndex].status != 1) {
      return
    }
    // 处理领取逻辑
    Dialog.loading()
    general.axios.post('/honorReceive', {
      index: item.index,
      level: item.levelNav[tagActiveIndex].level
    }).finally(() => {
      Dialog.close()
    }).then(res => {
      const { status } = res.data
      if (status.succeed) {
        const levelNav = item.levelNav
        levelNav[tagActiveIndex].status = 0
        levelNav[tagActiveIndex].buttonTitle = '已领取'
        setItem({ ...item, levelNav })
        Dialog.info('领取成功，请前往我的代金券中查看！')
      } else {
        Dialog.error(status.error_desc)
      }
    })
  }

  const voucherDiv = () => {
    return (
      <div className="vouchers">
        {item.levelNav[tagActiveIndex]?.vouchers.map(voucher => {
          return (
            <div className='voucher-item' key={voucher.id} style={{
              backgroundImage: 'url(/resources/modifyprice/voucherbg.png)',
              backgroundSize: '100% 100%',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
            }}>
              <div className="voucher-container">
                <div className="voucher-number">
                  <div className="amount">{voucher.amount}</div>
                  <div className="meet_amount">{voucher.meet_amount == '总价值' ? voucher.meet_amount : ('满' + voucher.meet_amount + '可用')}</div>
                </div>
                <div className="voucher-content">
                  <div className="voucher-name">{voucher.name}</div>
                  <div className="voucher-time">{voucher.time}</div>
                </div>
              </div>

            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div>
      <div className='exclusive-privileges-swiper-item' style={{ padding: item.index == 1 ? '0' : '0 15px' }}>
        <div>
          {item.index != 1 && <div className='header'>
            <div className="title">{item.h1}</div>
            <div className="desc">{item.tips}</div>
            {item.index > 1 && item.index < 5 && <div className="btn" onClick={() => setVisible(true)}>
              <span>奖励预览</span>
              <RightOutlined style={{ color: '#999', fontSize: '12px' }}></RightOutlined>
            </div>}
          </div>}
          <div className="tags">
            <Tabs
              style={{ '--active-line-height': '0' }}
              activeLineMode='fixed'
              stretch={false}
              activeKey={tagActiveIndex.toString()}
              onChange={idx => {
                setTagActiveIndex(idx)
                let amount = 0
                let meet_amount = 0
                let time = ''
                {
                  item.levelNav[idx].vouchers.map((item) => {
                    amount += parseInt(item.amount) * parseInt(item.num)
                    meet_amount += parseInt(item.num)
                    time = item.time
                  })
                }
                setVoucher({
                  amount: amount,
                  meet_amount: '总价值',
                  name: `共${meet_amount}张代金券`,
                  time: time
                })
              }}
            >
              {item.levelNav.map((item, tagIdx) => (
                <Tabs.Tab className='exclusive-privileges-tag' title={item.title} key={tagIdx} />
              ))}
            </Tabs>
          </div>
        </div>
        {item.index == 5 && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={item.banner} alt="" />
          {item?.service?.type == 'qrcode' && <img src={item.service.img} style={{ marginTop: '35px' }} alt="" height={128} />}
          { item?.service?.type == 'qrcode' && <div style={{
            width: '240px',
            textAlign: 'center',
            color: '#666',
            fontSize: '13px',
            paddingTop: '15px'
          }}>{item?.service?.tips}</div>}
          {item?.service?.type == 'jump_kefu' && <NavLink to='/service' style={{
            textAlign: 'center',
            color: '#3E2307',
            fontSize: '18px',
            fontWeight: '500',
            background: 'linear-gradient( #F9D6A5, #EAB070)',
            borderRadius: '25px',
            padding: '7px 20px',
            marginTop: '30px'
          }}>联系专属客服</NavLink>}
        </div>}
        <div style={{
          maxHeight: (item.index == 1 || item.index == 5 ? 'calc(100vh - 55px - 40px - env(safe-area-inset-top))' : 'calc(100vh - 92px - 55px - 40px - env(safe-area-inset-top))'),
          overflow: 'scroll'
        }}>
          {item.index != 5 && <div className="vouchertitle">
            {item.levelNav[tagActiveIndex]?.rewardTitle}
            {item.levelNav[tagActiveIndex]?.vouchers?.length > 1 && <div onClick={() => {
              setIsClose(e => !e)
            }}>
              <span className='action'>{isClose ? '展开' : '收起'}</span>
              <RightOutlined style={{ transform: isClose ? 'rotate(90deg)' : 'rotate(270deg)', fontSize: '11px', color: '#999' }}></RightOutlined>
            </div>}
          </div>}
          {item.index != 5 && isClose && item.levelNav[tagActiveIndex]?.vouchers?.length > 1 && <div className="vouchers">
            <div className='voucher-item' style={{
              backgroundImage: 'url(/resources/modifyprice/voucherbg.png)',
              backgroundSize: '100% 100%',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
            }}>
              <div className="voucher-container">
                <div className="voucher-number">
                  <div className="amount">{voucher.amount}</div>
                  <div className="meet_amount">{voucher.meet_amount == '总价值' ? voucher.meet_amount : ('满' + voucher.meet_amount + '可用')}</div>
                </div>
                <div className="voucher-content">
                  <div className="voucher-name">{voucher.name}</div>
                  <div className="voucher-time">{voucher.time}</div>
                </div>
              </div>
            </div>
          </div>}
          {item.index != 5 && !isClose && voucherDiv()}
          {item.index != 5 && item.levelNav[tagActiveIndex]?.vouchers?.length == 1 && voucherDiv()}
          {item.levelNav[tagActiveIndex]?.vouchers.length > 0 && <div onClick={() => handleReceive(item)} className={(item.levelNav[tagActiveIndex]?.status == 1 ? "receive-btn" : "receive-btn receive-btn-disabled")}>{item.levelNav[tagActiveIndex]?.buttonTitle}</div>}
          {item.levelNav[tagActiveIndex]?.vouchers.length > 0 && <div className="receive-desc">领取后可在“我的-代金券”查看</div>}
          {item.index == 1 && <div className='range-value' dangerouslySetInnerHTML={{ __html: item.html }}></div>}
          {item.index != 1 && <div className="voucher-desc">
            <div className="voucher-desc-header">
              <img src="resources/modifyprice/desc.png" height={17} alt="" />
            </div>
            <div className="range-title">权益范围</div>
            {item.index == 5 && <div className="range-value">{item.scopeRange}</div>}
            {item.index != 5 && item.index != 1 && <div className="range-value">{item.levelNav[tagActiveIndex]?.scopeRange}</div>}
            <div className="range-title">特权介绍</div>
            {item.index == 5 && <div className="range-value" dangerouslySetInnerHTML={{ __html: item.scopeDesc?.content.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2') }}></div>}
            {item.index != 5 && item.index != 1 && <div>
              <span className="range-value" dangerouslySetInnerHTML={{ __html: item.levelNav[tagActiveIndex]?.scopeDesc?.content.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2') }}></span>
              <span className='range-value'>（</span>
              <span style={{ color: '#F0C086', fontSize: '14px' }} onClick={() => setGamesVisible(true)}>{item.levelNav[tagActiveIndex]?.scopeDesc?.disabled}</span>
              <span className='range-value'>）</span>
            </div>}
          </div>}
        </div>
      </div>
      <Preview type={item.index - 1} visible={visible} handleDismiss={() => setVisible(false)}></Preview>
      <DisableGames visible={gamesVisible} handleDismiss={() => setGamesVisible(false)}></DisableGames>
    </div>
  )
}
